import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=11776a05&scoped=true&"
var script = {}
import style0 from "./notFound.vue?vue&type=style&index=0&id=11776a05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11776a05",
  null
  
)

export default component.exports